const pageNameKey = "otaAcceptAndPushFirmwareModal";

export const otaAcceptAndPushFirmwareModalEn = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Close accept and push firmware modal",
    closeModalAriaLabelBackup: "Close accept and push backup modal",
    titleFirmware: "Accept and Push Firmware",
    titleBackup: "Accept and Push Backup",
    firmwareSectionTitle: "The firmware",
    backupSectionTitle: "The backup",
    uploadedAtLabel: "uploaded",
    machineSectionTitle: "will be pushed to the machine",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "The target folder {targetPath} on the machine currently contains:",
    backupFoldersSectionTitle:
      "The target folder {targetPath} on the machine currently contains:",
    firmwarePackageFoldersSectionTitle:
      "The firmware package contains the following folders:",
    backupPackageFoldersSectionTitle:
      "The backup package contains the following folders:",
    warningText:
      "Do you want to overwrite the folders and files on the machine in the target folder?",
    cancelButtonText: "Cancel",
    acceptAndPushButtonTextFirmware: "Accept and Push Firmware",
    acceptAndPushButtonTextBackup: "Accept and Push Backup",
    startSuccessMessageFirmware: "Firmware installation started successfully.",
    startSuccessMessageBackup: "Backup installation started successfully.",
    startFailureMessageFirmware: "Failed to start firmware installation",
    startFailureMessageBackup: "Failed to start backup installation",
    startErrorMessageFirmware: "Error starting firmware installation",
    startErrorMessageBackup: "Error starting backup installation",
  },
};

export const otaAcceptAndPushFirmwareModalPtBr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Fechar modal de aceitar e enviar firmware",
    closeModalAriaLabelBackup: "Fechar modal de aceitar e enviar backup",
    titleFirmware: "Aceitar e enviar firmware",
    titleBackup: "Aceitar e enviar backup",
    firmwareSectionTitle: "O firmware",
    backupSectionTitle: "O backup",
    uploadedAtLabel: "enviado em",
    machineSectionTitle: "será enviado para a máquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "A pasta de destino {targetPath} na máquina atualmente contém:",
    backupFoldersSectionTitle:
      "A pasta de destino {targetPath} na máquina atualmente contém:",
    firmwarePackageFoldersSectionTitle:
      "O pacote de firmware contém as seguintes pastas:",
    backupPackageFoldersSectionTitle:
      "O pacote de backup contém as seguintes pastas:",
    warningText:
      "Deseja sobrescrever as pastas e arquivos na máquina na pasta de destino?",
    cancelButtonText: "Cancelar",
    acceptAndPushButtonTextFirmware: "Aceitar e enviar firmware",
    acceptAndPushButtonTextBackup: "Aceitar e enviar backup",
    startSuccessMessageFirmware: "Instalação do firmware iniciada com sucesso.",
    startSuccessMessageBackup: "Instalação do backup iniciada com sucesso.",
    startFailureMessageFirmware: "Falha ao iniciar a instalação do firmware",
    startFailureMessageBackup: "Falha ao iniciar a instalação do backup",
    startErrorMessageFirmware: "Erro ao iniciar a instalação do firmware",
    startErrorMessageBackup: "Erro ao iniciar a instalação do backup",
  },
};

export const otaAcceptAndPushFirmwareModalDe = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Modal für Firmware akzeptieren und übertragen schließen",
    closeModalAriaLabelBackup:
      "Modal für Backup akzeptieren und übertragen schließen",
    titleFirmware: "Firmware akzeptieren und übertragen",
    titleBackup: "Backup akzeptieren und übertragen",
    firmwareSectionTitle: "Die Firmware",
    backupSectionTitle: "Das Backup",
    uploadedAtLabel: "hochgeladen",
    machineSectionTitle: "wird auf die Maschine übertragen",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "Der Zielordner {targetPath} auf der Maschine enthält derzeit:",
    backupFoldersSectionTitle:
      "Der Zielordner {targetPath} auf der Maschine enthält derzeit:",
    firmwarePackageFoldersSectionTitle:
      "Das Firmware-Paket enthält folgende Ordner:",
    backupPackageFoldersSectionTitle:
      "Das Backup-Paket enthält folgende Ordner:",
    warningText:
      "Möchten Sie die Ordner und Dateien auf der Maschine im Zielordner überschreiben?",
    cancelButtonText: "Abbrechen",
    acceptAndPushButtonTextFirmware: "Firmware akzeptieren und übertragen",
    acceptAndPushButtonTextBackup: "Backup akzeptieren und übertragen",
    startSuccessMessageFirmware: "Firmware-Installation erfolgreich gestartet.",
    startSuccessMessageBackup: "Backup-Installation erfolgreich gestartet.",
    startFailureMessageFirmware:
      "Firmware-Installation konnte nicht gestartet werden",
    startFailureMessageBackup:
      "Backup-Installation konnte nicht gestartet werden",
    startErrorMessageFirmware: "Fehler beim Starten der Firmware-Installation",
    startErrorMessageBackup: "Fehler beim Starten der Backup-Installation",
  },
};

export const otaAcceptAndPushFirmwareModalZhHans = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "关闭接受并推送固件弹窗",
    closeModalAriaLabelBackup: "关闭接受并推送备份弹窗",
    titleFirmware: "接受并推送固件",
    titleBackup: "接受并推送备份",
    firmwareSectionTitle: "该固件",
    backupSectionTitle: "该备份",
    uploadedAtLabel: "上传于",
    machineSectionTitle: "将被推送到设备",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle: "设备上的目标文件夹 {targetPath} 当前包含：",
    backupFoldersSectionTitle: "设备上的目标文件夹 {targetPath} 当前包含：",
    firmwarePackageFoldersSectionTitle: "固件包包含以下文件夹：",
    backupPackageFoldersSectionTitle: "备份包包含以下文件夹：",
    warningText: "您是否要覆盖目标文件夹中机器上的文件夹和文件？",
    cancelButtonText: "取消",
    acceptAndPushButtonTextFirmware: "接受并推送固件",
    acceptAndPushButtonTextBackup: "接受并推送备份",
    startSuccessMessageFirmware: "固件安装已成功开始。",
    startSuccessMessageBackup: "备份安装已成功开始。",
    startFailureMessageFirmware: "启动固件安装失败",
    startFailureMessageBackup: "启动备份安装失败",
    startErrorMessageFirmware: "启动固件安装时出错",
    startErrorMessageBackup: "启动备份安装时出错",
  },
};

export const otaAcceptAndPushFirmwareModalIt = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Chiudi finestra accetta e invia firmware",
    closeModalAriaLabelBackup: "Chiudi finestra accetta e invia backup",
    titleFirmware: "Accetta e invia firmware",
    titleBackup: "Accetta e invia backup",
    firmwareSectionTitle: "Il firmware",
    backupSectionTitle: "Il backup",
    uploadedAtLabel: "caricato il",
    machineSectionTitle: "verrà inviato alla macchina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "La cartella di destinazione {targetPath} sulla macchina contiene attualmente:",
    backupFoldersSectionTitle:
      "La cartella di destinazione {targetPath} sulla macchina contiene attualmente:",
    firmwarePackageFoldersSectionTitle:
      "Il pacchetto firmware contiene le seguenti cartelle:",
    backupPackageFoldersSectionTitle:
      "Il pacchetto backup contiene le seguenti cartelle:",
    warningText:
      "Vuoi sovrascrivere le cartelle e i file sulla macchina nella cartella di destinazione?",
    cancelButtonText: "Annulla",
    acceptAndPushButtonTextFirmware: "Accetta e invia firmware",
    acceptAndPushButtonTextBackup: "Accetta e invia backup",
    startSuccessMessageFirmware: "Installazione firmware avviata con successo.",
    startSuccessMessageBackup: "Installazione backup avviata con successo.",
    startFailureMessageFirmware:
      "Impossibile avviare l'installazione del firmware",
    startFailureMessageBackup: "Impossibile avviare l'installazione del backup",
    startErrorMessageFirmware:
      "Errore durante l'avvio dell'installazione firmware",
    startErrorMessageBackup: "Errore durante l'avvio dell'installazione backup",
  },
};

export const otaAcceptAndPushFirmwareModalEs = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware: "Cerrar modal de aceptar y enviar firmware",
    closeModalAriaLabelBackup: "Cerrar modal de aceptar y enviar respaldo",
    titleFirmware: "Aceptar y enviar firmware",
    titleBackup: "Aceptar y enviar respaldo",
    firmwareSectionTitle: "El firmware",
    backupSectionTitle: "El respaldo",
    uploadedAtLabel: "subido el",
    machineSectionTitle: "se enviará a la máquina",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "La carpeta de destino {targetPath} en la máquina contiene actualmente:",
    backupFoldersSectionTitle:
      "La carpeta de destino {targetPath} en la máquina contiene actualmente:",
    firmwarePackageFoldersSectionTitle:
      "El paquete de firmware contiene las siguientes carpetas:",
    backupPackageFoldersSectionTitle:
      "El paquete de respaldo contiene las siguientes carpetas:",
    warningText:
      "¿Desea sobrescribir las carpetas y archivos en la máquina en la carpeta de destino?",
    cancelButtonText: "Cancelar",
    acceptAndPushButtonTextFirmware: "Aceptar y enviar firmware",
    acceptAndPushButtonTextBackup: "Aceptar y enviar respaldo",
    startSuccessMessageFirmware:
      "La instalación del firmware se inició correctamente.",
    startSuccessMessageBackup:
      "La instalación del respaldo se inició correctamente.",
    startFailureMessageFirmware:
      "No se pudo iniciar la instalación del firmware",
    startFailureMessageBackup: "No se pudo iniciar la instalación del respaldo",
    startErrorMessageFirmware: "Error al iniciar la instalación del firmware",
    startErrorMessageBackup: "Error al iniciar la instalación del respaldo",
  },
};

export const otaAcceptAndPushFirmwareModalNl = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Modal voor firmware accepteren en pushen sluiten",
    closeModalAriaLabelBackup:
      "Modal voor back-up accepteren en pushen sluiten",
    titleFirmware: "Firmware accepteren en pushen",
    titleBackup: "Back-up accepteren en pushen",
    firmwareSectionTitle: "De firmware",
    backupSectionTitle: "De back-up",
    uploadedAtLabel: "geupload op",
    machineSectionTitle: "wordt naar de machine gepusht",
    machineIdLabel: "ID",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "De doelmap {targetPath} op de machine bevat momenteel:",
    backupFoldersSectionTitle:
      "De doelmap {targetPath} op de machine bevat momenteel:",
    firmwarePackageFoldersSectionTitle:
      "Het firmwarepakket bevat de volgende mappen:",
    backupPackageFoldersSectionTitle:
      "Het back-uppakket bevat de volgende mappen:",
    warningText:
      "Wilt u de mappen en bestanden op de machine in de doelmap overschrijven?",
    cancelButtonText: "Annuleren",
    acceptAndPushButtonTextFirmware: "Firmware accepteren en pushen",
    acceptAndPushButtonTextBackup: "Back-up accepteren en pushen",
    startSuccessMessageFirmware: "Firmware-installatie is succesvol gestart.",
    startSuccessMessageBackup: "Back-upinstallatie is succesvol gestart.",
    startFailureMessageFirmware: "Starten van firmware-installatie is mislukt",
    startFailureMessageBackup: "Starten van back-upinstallatie is mislukt",
    startErrorMessageFirmware: "Fout bij starten van firmware-installatie",
    startErrorMessageBackup: "Fout bij starten van back-upinstallatie",
  },
};

export const otaAcceptAndPushFirmwareModalTr = {
  [pageNameKey]: {
    closeModalAriaLabelFirmware:
      "Ürün yazılımını kabul et ve gönder penceresini kapat",
    closeModalAriaLabelBackup: "Yedeği kabul et ve gönder penceresini kapat",
    titleFirmware: "Bellenimi Kabul Et ve Gönder",
    titleBackup: "Yedeklemeyi Kabul Et ve Gönder",
    firmwareSectionTitle: "Ürün yazılımı",
    backupSectionTitle: "Yedekleme",
    uploadedAtLabel: "yüklendi",
    machineSectionTitle: "makineye itilecek",
    machineIdLabel: "İD",
    machineIpLabel: "IP",
    firmwareFoldersSectionTitle:
      "Makinedeki {targetPath} hedef klasörü şu anda şunları içeriyor:",
    backupFoldersSectionTitle:
      "Makinedeki {targetPath} hedef klasörü şu anda şunları içeriyor:",
    firmwarePackageFoldersSectionTitle:
      "Ürün yazılımı paketi aşağıdaki klasörleri içerir:",
    backupPackageFoldersSectionTitle:
      "Yedekleme paketi aşağıdaki klasörleri içerir:",
    warningText:
      "Hedef klasördeki makinedeki klasörlerin ve dosyaların üzerine yazmak istiyor musunuz?",
    cancelButtonText: "İptal etmek",
    acceptAndPushButtonTextFirmware: "Bellenimi Kabul Et ve Gönder",
    acceptAndPushButtonTextBackup: "Yedeklemeyi Kabul Et ve Gönder",
    startSuccessMessageFirmware: "Firmware kurulumu başarıyla başladı.",
    startSuccessMessageBackup: "Yedekleme kurulumu başarıyla başladı.",
    startFailureMessageFirmware: "Ürün yazılımı yüklemesi başlatılamadı",
    startFailureMessageBackup: "Yedekleme kurulumu başlatılamadı",
    startErrorMessageFirmware: "Firmware kurulumu başlatılırken hata oluştu",
    startErrorMessageBackup: "Yedekleme kurulumu başlatılırken hata oluştu",
  },
};
